export const lang = {
	UPDATE: 'Update Card',
	PRICE: (price: string) => `Pay ${price}`,
	PRICE_ON_DATE: (price: string, date: string) => `Pay ${price} on ${date}`
};
